import { forkJoin, Observable } from "rxjs";
import * as http from "../../../../../services/http.service";
import { SearchResults } from "../../../../../types/search/search-results.interface";
import { map } from "rxjs/operators";
import { WorkOrderUploadAssetResponse } from "../types/work-order-upload-asset-response.interface";
import { Nullable } from "../../../../../types/common";
import { IAsset } from "../../../../../features/file-attachments/types/file-attachment.interface";

export function fetchAssets(workOrderId: number): Observable<IAsset[]> {
  return http
    .get<SearchResults<WorkOrderUploadAssetResponse>>(`/work-orders/${workOrderId}/attachments/`)
    .pipe(
      map((response) => response.results),
      map(mapWorkOrderUploadAssetResponsesToWorkOrderAssets)
    );
}

export function deleteAsset(assetId: number): Observable<void> {
  if (!assetId || isNaN(assetId)) {
    throw new Error(`Invalid asset Id ${assetId}`);
  }
  return http.del(`/work-orders/attachments/${assetId}/`);
}

export function uploadAssets(assets: File[], workOrderId: number): Observable<IAsset[]> {
  return forkJoin(assets.map((asset) => doUploadAsset(asset, workOrderId)));
}

function doUploadAsset(asset: File, workOrderId: number): Observable<IAsset> {
  const formData = new FormData();
  formData.set("attachment", asset);
  formData.set("is_asset", "1");
  formData.set("work_order", `${workOrderId}`);

  return http
    .post<WorkOrderUploadAssetResponse>(`/work-orders/${workOrderId}/attachments/`, formData)
    .pipe(map(mapWorkOrderUploadAssetResponseToWorkOrderAsset));
}

const mapWorkOrderUploadAssetResponsesToWorkOrderAssets = (
  responses: WorkOrderUploadAssetResponse[]
): IAsset[] => responses.map(mapWorkOrderUploadAssetResponseToWorkOrderAsset);

const mapWorkOrderUploadAssetResponseToWorkOrderAsset = (
  response: WorkOrderUploadAssetResponse
): IAsset => {
  return {
    id: response.id,
    createdAt: response.createdAt,
    url: response.attachment,
    description: response.description,
    mimetype: response.mimetype,
    size: response.size,
    workOrderStatus: response.workOrderDetails.status,
  };
};

export const addAssetsToAssets = (newAssets: IAsset[], currentAssets: Nullable<IAsset[]>) =>
  (currentAssets || []).concat(newAssets);

export const removeAssetFromAssets = (assetId: number, currentAssets: Nullable<IAsset[]>) =>
  (currentAssets || []).filter((asset) => asset.id !== assetId);
